import { useState } from "react";
import Campo from "../Campo";
import styles from "./styles.module.css";
import VerificaForm from "../../controllers/VerificaForm";
import CampoTextoLongo from "../Campo/CampoTextoLongo";
import { MetaFisica } from "../../model/PlanoDeTrabalho/CronogramaExecucao";
import CampoSelect from "../Campo/CampoSelect";
import { UnidadeDeMedida } from "../../enums/UnidadeDeMedida";
import CampoDate from "../Campo/CampoDate";
import { toIsoString } from "../../controllers/Converters";
import {
  addList,
  editList,
  removeList,
} from "../../controllers/ListOperations";

type Props = {
  refMeta?: MetaFisica;
  closeModal: Function;
  list: MetaFisica[];
  setList: Function;
  index?: number;
};

const ModalMetaExecucaoFisica = ({
  refMeta,
  closeModal,
  list,
  setList,
  index,
}: Props) => {
  const [etapa, setEtapa] = useState(refMeta?.etapa || 1);
  const [fase, setFase] = useState(refMeta?.fase || 1);
  const [inicio, setInicio] = useState(refMeta?.inicio || new Date(Date.now()));
  const [fim, setFim] = useState(refMeta?.fim || new Date(Date.now()));
  const [unidadeMedida, setUnidadeMedida] = useState(
    refMeta?.unidade_medida || UnidadeDeMedida.mes
  );
  const [quantidade, setQuantidade] = useState(refMeta?.quantidade || 1);
  const [descricaoMeta, setDescricaoMeta] = useState(refMeta?.descricao || "");

  return (
    <form className={styles.formModal}>
      <h2>Criar uma Meta de Execução</h2>
      <div className={styles.gridCampos}>
        <div className={styles.gridCampos}>
          <Campo
            title="Etapa"
            type="number"
            placeholder="Digite o Titulo do seu Projeto ou Atividade"
            maxLength={64}
            required={true}
            customValidity="Preencha com o Titulo do seu Projeto"
            setter={setEtapa}
            value={etapa}
          />

          <Campo
            title="Fase"
            type="number"
            placeholder="Digite o nome do Órgão/Entidade Financiador"
            maxLength={64}
            required={true}
            customValidity="Preencha com o Órgão/Entidade Financiador"
            setter={setFase}
            value={fase}
          />
        </div>
        <div className={styles.gridCampos}>
          <CampoDate
            title="Inicio"
            showAsterisk
            customValidity="A data de inicio deve ser uma data valida e estar no futuro"
            setter={setInicio}
            value={inicio}
          />
          <CampoDate
            title="Fim"
            showAsterisk
            customValidity="A data de Fim deve ser uma data valida e posterior a data de Inincio"
            min={
              inicio
                ? toIsoString(new Date(inicio))
                : toIsoString(new Date(Date.now()))
            }
            setter={setFim}
            value={fim}
          />
        </div>
        <CampoSelect
          title="Unidade de Medida"
          setter={setUnidadeMedida}
          value={unidadeMedida}
        >
          <option value={UnidadeDeMedida.dia}>Dias</option>
          <option value={UnidadeDeMedida.semana}>Semanas</option>
          <option
            value={UnidadeDeMedida.mes}
            defaultValue={UnidadeDeMedida.mes}
          >
            Mêses
          </option>
          <option value={UnidadeDeMedida.ano}>Anos</option>
        </CampoSelect>
        <Campo
          title="Quantidade"
          type="text"
          placeholder="Digite o nome do Órgão/Entidade Financiador"
          maxLength={64}
          required={true}
          customValidity="Preencha com o Órgão/Entidade Financiador"
          setter={setQuantidade}
          value={quantidade}
        />
      </div>
      <CampoTextoLongo
        title="Descrição da Meta"
        placeholder="Descreva a forma que o Projeto ou Atividade sera Executada"
        required={true}
        customValidity="Preencha com a Forma de Execução do Projeto ou Atividade"
        setter={setDescricaoMeta}
        value={descricaoMeta}
      />
      <hr className={styles.separador} />

      {!refMeta && (
        <input
          type="submit"
          value="+ Adicionar Meta de Execução"
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            if (VerificaForm(e.currentTarget.form)) {
              const item: MetaFisica = {
                etapa: etapa,
                fase: fase,
                inicio: new Date(inicio).toISOString().split("T")[0],
                fim: new Date(fim).toISOString().split("T")[0],
                quantidade: quantidade,
                unidade_medida: unidadeMedida,
                descricao: descricaoMeta,
              };
              addList({ item, list, setList });

              closeModal();
            }
          }}
        />
      )}

      {refMeta !== undefined && index !== undefined && (
        <div className={styles.gridCampos}>
          <input
            type="submit"
            value="Editar Meta"
            className={styles.editBtn}
            onClick={(e) => {
              e.preventDefault();
              closeModal();
              if (VerificaForm(e.currentTarget.form)) {
                const item: MetaFisica = {
                  etapa: etapa,
                  fase: fase,
                  inicio: new Date(inicio).toISOString().split("T")[0],
                  fim: new Date(fim).toISOString().split("T")[0],
                  quantidade: quantidade,
                  unidade_medida: unidadeMedida,
                  descricao: descricaoMeta,
                };
                editList({
                  index,
                  item,
                  list,
                  setList,
                });

                closeModal();
              }
            }}
          />
          <input
            type="submit"
            value="Remover Meta"
            className={styles.removeBtn}
            onClick={(e) => {
              e.preventDefault();
              removeList({ index, list, setList });
              closeModal();
            }}
          />
        </div>
      )}
    </form>
  );
};

export default ModalMetaExecucaoFisica;
